<template>
  <div class="vacancy-main__toggle-bookmarks-small-wrap">
    <button v-if="inBookmarks"
            @click.prevent="$emit('toggle')"
            class="vacancy-main__toggle-bookmarks-small  _active">
      <BaseSvg name="ico-heart"/>
    </button>
    <button v-else
            @click.prevent="$emit('toggle')"
            class="vacancy-main__toggle-bookmarks-small">
      <BaseSvg name="ico-heart-outline"/>
    </button>
    <BasePreloader v-if="pending"
                   class="_small"/>
  </div>
</template>

<script>
  export default {
    name: 'VacancyMainBookmarksShortBtn',
    props: {
      inBookmarks: Boolean,
      pending: Boolean,
    }
  }
</script>

<style lang="less">

</style>
